export default __webpack_public_path__ + "static/media/movie1.8a9f2200.PNG";